﻿import {
    SET_PARAGRAFER,
    UPDATE_PARAGRAFER,
    ParagraferState,
    StateActionTypes,
    SET_FEILMELDING,
} from './Types';

import { ThunkAction, ThunkDispatch } from 'redux-thunk';
import { AppState } from '.';
import { AnyAction } from 'redux';
import * as RegelApi from '../Models/ResultViewModel';

export function setFeilmelding(): StateActionTypes {
    return {
        type: SET_FEILMELDING,
        payload: {
            loading: false,
            visFeilmelding: false,
        }
    }
}

export function set(state: ParagraferState): StateActionTypes {
    state.paragrafer!.forEach((p: RegelApi.ParagrafViewModel) => {
        if (p.id === state.sisteAktiveLamell) {
            p.active = true;
        }

      
    });

    return {
        type: SET_PARAGRAFER,
        payload: {
            paragrafer: state.paragrafer,
            loading: state.loading,
            sisteAktiveLamell: state.sisteAktiveLamell,
            firstLoadReady: false,
            kapittelMerknadOverskrift: state.kapittelMerknadOverskrift,
            kapittelMerknadTekst: state.kapittelMerknadTekst,
            kapittelMerknadLenketekst: state.kapittelMerknadLenketekst,
            visFeilmelding: state.visFeilmelding,
        }
    }
}

export function update(state: ParagraferState): StateActionTypes {
    return {
        type: UPDATE_PARAGRAFER,
        payload: {
            paragrafer: state.paragrafer,
            loading: state.loading,
            sisteAktiveLamell: state.sisteAktiveLamell,
            firstLoadReady: false,
            modalOpen: state.modalOpen,
            kapittelMerknadOverskrift: state.kapittelMerknadOverskrift,
            kapittelMerknadTekst: state.kapittelMerknadTekst,
            kapittelMerknadLenketekst: state.kapittelMerknadLenketekst,
            visFeilmelding: state.visFeilmelding,
        }
    }
}

export const updateParagrafer = (clickedParagraf: string): ThunkAction<void, AppState, {}, AnyAction> => {
    return (
        dispatch: ThunkDispatch<AppState, {}, AnyAction>, getState: () => AppState
    ): void => {
        const currentState = getState();
        currentState!.paragraferState!.paragrafer!.forEach((p: RegelApi.ParagrafViewModel) => {           
            if (p.id === clickedParagraf) {
                const currentStatus: boolean = p.active;
                p.active = !currentStatus;

                let paragrafArea = document.getElementById('paragraf-' + p.id) as HTMLDivElement;               

                if (p.active) {
                    // var lukket, nå er den aktiv ("åpne")
                    currentState.paragraferState.sisteAktiveLamell = p.id;
                    history.replaceState(null, "", '#' + p.id);

                    paragrafArea.style.overflow = "hidden";
                    paragrafArea.style.display = "block";
                    paragrafArea.style.minHeight = "0";
                    paragrafArea.classList.remove('sr-only');
                    let height: number = paragrafArea.clientHeight;

                    dispatch(
                        update(currentState.paragraferState),
                    );

                    paragrafArea.animate([
                        // keyframes
                        { height: '0' },
                        { height: height + 'px' }
                    ], {
                        // timing options
                        duration: 200,
                        iterations: 1
                    });
                    
                } else {
                    // var aktiv, nå lukkes den ("lukk")
                    let height: number = paragrafArea.clientHeight;
                    paragrafArea.style.overflow = "hidden";
                    
                    paragrafArea.animate([
                        // keyframes
                        { height: height + 'px' },
                        { height: '0' }
                    ], {
                        // timing options
                        duration: 200,
                        iterations: 1
                    }).finished.then(function () {
                        paragrafArea.classList.add('sr-only');

                        dispatch(
                            update(currentState.paragraferState),
                        );

                        if (typeof (paragrafArea as any).scrollIntoViewIfNeeded !== "undefined") {
                            (paragrafArea as any).scrollIntoViewIfNeeded(false);
                        } else {
                            paragrafArea.scrollIntoView();
                        }
                    });
                }
            }
        });
    };
}

export const visMerknad = (paragrafId: string | undefined): ThunkAction<void, AppState, {}, AnyAction> => {
    return (
        dispatch: ThunkDispatch<AppState, {}, AnyAction>, getState: () => AppState
    ): void => {
        const currentState = getState();
        currentState.paragraferState.modalOpen = paragrafId;

        dispatch(
            update(currentState.paragraferState),
        );
    }
}
